export enum DialogType {
  BreachZoneNotAllowed = 'BREACH_ZONE_NOT_ALLOWED',
  DeletingGeofence = 'DELETING_GEOFENCE',
  DeletingLayer = 'DELETING_LAYER',
  DeletingMicrofence = 'DELETING_MICROFENCE',
  DirtySave = 'DIRTY_SAVE',
  LayerConflict = 'LAYER_CONFLICT',
  Generic = 'GENERIC',
  ReassigningToLayer = 'REASSIGNING_TO_LAYER',
  UploadLayerJson = 'UPLOAD_LAYER_JSON',
}
